import { fetchDataFromBackend } from "../api/api";
import logger from "../core/utils/logger";

const isSimulation = import.meta.env.VITE_BACKEND_DATA_SIMULATION === "true";

// Helper: Generate simulated month plan data
const generateSimulatedMonthPlanData = (month, year, count = 100) => {
    const daysInMonth = new Date(year, month, 0).getDate();
    return Array.from({ length: count }).map((_, index) => {
        const userId = `user-${index + 1}`;
        const userName = `User ${index + 1}`;
        const dailyStatuses = {};
        for (let day = 1; day <= daysInMonth; day++) {
            const date = new Date(year, month - 1, day);
            const dateStr = date.toISOString().split("T")[0];
            dailyStatuses[dateStr] = {
                status: mapStatusCodeToName(Math.floor(Math.random() * 9))
            };
        }
        return {
            userId,
            userName,
            schedule: dailyStatuses
        };
    });
};

function mapStatusCodeToName(code) {
    // Example mapping, adjust as needed
    switch (code) {
        case 0: return "Work";
        case 1: return "Holiday";
        case 2: return "Weekend";
        case 3: return "Sick";
        case 4: return "Off";
        case 5: return "TimeCompensation";
        case 6: return "EmergencyService";
        case 7: return "ChildSick";
        case 8: return "PublicHoliday";
        default: return "Unknown";
    }
}

// Converter: Transform backend month plan data to simulated format
function convertBackendMonthPlanData(backendData) {
    if (!Array.isArray(backendData)) return [];
    return backendData.map(user => {
        const userId = user.userId || user.id;
        const userName = user.userName || user.email || "";
        const schedule = {};
        // Assume only one calendar per user per month
        const calendar = (user.employeeMonthlyCalendar && user.employeeMonthlyCalendar[0]) || null;
        if (calendar && Array.isArray(calendar.dailyPlanEmployees)) {
            calendar.dailyPlanEmployees.forEach(dayPlan => {
                // Use only the date part (YYYY-MM-DD)
                const dateStr = dayPlan.date.split("T")[0];
                schedule[dateStr] = {
                    status: mapStatusCodeToName(dayPlan.dayStatus)
                };
            });
        }
        return { userId, userName, schedule };
    });
}

export const MonthPlanService = {
    async getUserMonthPlan(month, year) {
        try {
            logger.log("🚀 MonthPlanService.getUserMonthPlan CALLED");
            if (isSimulation) {
                logger.log(`Simulation mode: generating month plan for month ${month}, year ${year}`);
                const simulated = generateSimulatedMonthPlanData(month, year, 100);
                logger.log("✅ First Simulated Month Record:", JSON.stringify(simulated[0], null, 2));
                return simulated;
            }
            const response = await fetchDataFromBackend(`/MonthPlanEmployee/GetMonthPlanEmployeeByOrgIdInMonthAndYear?month=${month}&year=${year}`, { skipAuth: false, method: 'get' });
            logger.log("User month plan response:", JSON.stringify(response));
            // Convert backend data to simulated format
            const converted = convertBackendMonthPlanData(response);
            logger.log("✅ First Converted Month Record:", JSON.stringify(converted[0], null, 2));
            return converted;
        } catch (error) {
            logger.error("Error getting user month plan:", error);
            throw error;
        }
    }
};
